export const SEGMENT_SHOW_TABS = ['general'] as const;

export type SegmentShowTab = (typeof SEGMENT_SHOW_TABS)[number];

export const SEGMENT_DEFAULT_TAB: SegmentShowTab = 'general';
